import React from 'react';
import { motion } from 'framer-motion';
import PrimaryButton from '../../../components/shacdn/PrimaryButton';
import bg from '@/assets/homepage/bg3.png';

const ContactSection: React.FC = () => (
  <section className='relative px-4 w-full py-20 bg-white z-10 max-[560px]:py-4 max-[560px]:mb-8'>
    <div
      className='max-w-[1280px]  bg-no-repeat	 mx-auto px-4 flex flex-col items-center gap-8 rounded-3xl py-16'
      style={{ backgroundImage: `url(${bg})` }}
    >
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className='text-4xl max-[560px]:text-3xl max-w-[636px] font-semibold text-white text-center'
      >
        Having an idea? Let us know and together we’ll make it come true!
      </motion.h2>
      <motion.div
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <PrimaryButton variant='primary'>Work with us</PrimaryButton>
      </motion.div>
    </div>
  </section>
);

export default ContactSection;
